<!-- home.component.html -->
<div class="flex h-full gap-2">

  <!-- Main Content -->
  <main class="flex-grow flex justify-center items-center flex-col">
    <h1 class="text-2xl font-bold">Willkommen auf necta.supply</h1>
    <span>Temporäres Menü für die Entwicklung</span>
  </main>
</div>
